import React, { useState, useEffect } from 'react'
import { TopBar, TopBarSection, TopBarTitle, WidgetContent } from '@duik/it'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import TableHeader from '../UI/TableHeader'
import TopBarMenuDivider from '../UI/TopBarMenuDivider'
import ArrowBackIcon from '@material-ui/icons/ArrowBackOutlined'
import LoadingIcon from '../components/LoadingIcon'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSnackBarCopy, toggleSnackBar } from '../UI/Store/actions'
import TruckItem from './TruckItem'
import moment from 'moment'
import { sendDriverNotification, replaceDriver, cancelDriver } from './Store/actions'
import ReplaceTruck from './Modals/ReplaceTruck'
import AssignTruck from './Modals/AssignTruck'
import RemoveTruck from './Modals/RemoveTruck'
import Snackbar from '../UI/Snackbar'
import { AssignTruckButton } from './styles'
import SmConfirmModal from 'UI/SmConfirmModal'

const DispatchTrucks = props => {
  const [searchedValue] = useState('')
  const [searchFilter] = useState(false)
  const [dispatchList, setDispatchList] = useState(props.dispatches.dispatchList)
  const [dispatch, setDispatch] = useState()
  const [dispatchDetail, setDispatchDetail] = useState()
  const [loading, setLoading] = useState(true)
  const [replaceTruckModal, setReplaceTruckModal] = useState(false)
  const [replaceTruckDetail, setReplaceTruckDetail] = useState()
  const [assignTruckModal, setAssignTruckModal] = useState(false)
  const [cancelTruckModal, setCancelTruckModal] = useState(false)
  const [cancelledNotes, setCancelledNotes] = useState('')
  const [removeTruckNotesModal, setRemoveTruckNotesModal] = useState(false)

  const handleReplaceTruckPress = _id => {
    const replaceTruckItem = dispatchDetail.find(item => item._id === _id)
    setReplaceTruckDetail(replaceTruckItem)
    setReplaceTruckModal(true)
  }

  const handleCancelTruckPress = _id => {
    const replaceTruckItem = props.dispatches.driverDispatchList.find(item => item._id === _id)
    setReplaceTruckDetail(replaceTruckItem)
    setCancelTruckModal(true)
  }

  const handleConfirmCancelTruck = () => {
    setCancelTruckModal(false)
    setRemoveTruckNotesModal(true)
  }

  const handleCancelTruck = () => {
    props.cancelDriver({ ...replaceTruckDetail, cancelledNotes })
    setRemoveTruckNotesModal(false)
    setDispatchDetail(dispatchDetail.filter(item => item._id !== replaceTruckDetail._id))
    setReplaceTruckDetail()
    props.setSnackBarCopy('Truck Removed')
    handleSnackBar()
  }

  const handleReplaceTruckModalClose = isSave => {
    if (isSave) {
      props.setSnackBarCopy('Truck Replaced')
      handleSnackBar()
    }
    setReplaceTruckModal(false)
    setReplaceTruckDetail()
    getDispatchDetails()
  }

  const handleAssignTruckPress = _id => {
    const replaceTruckItem = dispatchDetail.find(item => item._id === _id)
    setReplaceTruckDetail(replaceTruckItem)
    setAssignTruckModal(true)
  }

  const handleAssignTruckModalClose = isSave => {
    if (isSave) {
      props.setSnackBarCopy('Trucks Assigned')
      handleSnackBar()
    }
    setAssignTruckModal(false)
    getDispatchDetails()
  }

  const getDispatchDetails = () => {
    setDispatchDetail(
      props.dispatches.driverDispatchList.filter(item => item.dispatchId === props.match.params.id)
    )
    setDispatch(props.dispatches.dispatchList.find(item => item._id === props.match.params.id))
    setLoading(false)
  }

  const handleSendDriverNotification = _id => {
    props.setSnackBarCopy('Request Resent')
    props.sendDriverNotification(_id)
    handleSnackBar()
  }

  const handleSnackBar = () => {
    props.toggleSnackBar(true)
    setTimeout(() => {
      props.toggleSnackBar(false)
    }, 2500)
  }

  useEffect(() => {
    if (!props.loading) {
      getDispatchDetails()
    }
  }, [props.loading]) //eslint-disable-line

  if (props.loading || loading) {
    return <div />
  }
  return (
    <MainContainer>
      {/* <div style={{ width: '100%' }}>
        <TopBar>
          <TopBarSection>
            <h2
              className="uik-top-bar-title__wrapper"
              style={{ paddingLeft: '25px', width: 'fit-content' }}
            >
              Dispatches &gt; Trucks
            </h2>
          </TopBarSection>
        </TopBar>
      </div> */}
      <TableContainer>
        <WidgetContent style={{ padding: '8px 0px' }} className="uik-widget-content__wrapper">
          <TopBarSection style={{ padding: '0 30px' }}>
            <TopBarTitle>
              <ArrowBackIcon onClick={() => props.history.goBack()} />
              Trucks
            </TopBarTitle>
            <TopBarMenuDivider />
            {props.dispatches.loading && <LoadingIcon />}
            {!props.dispatches.loading && (
              <p style={{ fontSize: '0.875rem', color: '#9EA0A5', padding: '0 15px' }}>
                {!searchFilter &&
                  dispatchDetail &&
                  searchedValue.length === 0 &&
                  `${dispatchDetail.length} Drivers`}
                {!dispatchDetail && `0 Drivers`}
                {searchFilter &&
                  `${dispatchList.length}  ${
                    dispatchList.length > 1 ? 'Drivers' : 'Driver '
                  } found for '${searchedValue}'`}
              </p>
            )}
          </TopBarSection>
        </WidgetContent>

        <TableSection>
          <thead></thead>
          <tbody>
            {dispatchDetail.map((item, i) => {
              if (
                i === 0 ||
                dispatchDetail[i].startDateTime !== dispatchDetail[i - 1].startDateTime
              ) {
                const hasEnoughTrucks = dispatchDetail.length >= Number(dispatch.trucksRequired)
                return (
                  <>
                    <tr>
                      {[
                        moment(dispatchDetail[i].startDateTime).format('HH:mm'),
                        '',
                        '',
                        '',
                        '',
                        !hasEnoughTrucks ? (
                          <AssignTruckButton onClick={() => handleAssignTruckPress(item._id)}>
                            + Assign Trucks
                          </AssignTruckButton>
                        ) : (
                          ''
                        )
                      ].map((item, i) => (
                        <TableHeader title={item} key={i} />
                      ))}
                    </tr>
                    <TruckItem
                      dispatchItem={item}
                      key={i}
                      index={i}
                      sendDriverNotification={handleSendDriverNotification}
                      handleReplaceTruckPress={handleReplaceTruckPress}
                      handleCancelTruckPress={handleCancelTruckPress}
                    />
                  </>
                )
              }
              return (
                <TruckItem
                  dispatchItem={item}
                  key={i}
                  index={i}
                  sendDriverNotification={handleSendDriverNotification}
                  handleReplaceTruckPress={handleReplaceTruckPress}
                  handleCancelTruckPress={handleCancelTruckPress}
                />
              )
            })}
          </tbody>
        </TableSection>
      </TableContainer>
      {replaceTruckModal && (
        <ReplaceTruck
          truckDetail={replaceTruckDetail}
          drivers={props.drivers}
          handleReplaceTruckModalClose={() => handleReplaceTruckModalClose()}
          replaceDriver={props.replaceDriver}
        />
      )}
      {assignTruckModal && (
        <AssignTruck
          truckDetail={replaceTruckDetail}
          drivers={props.drivers}
          handleAssignTruckModalClose={() => handleAssignTruckModalClose()}
          assignDriver={props.replaceDriver}
          dispatch={dispatch}
          dispatchDetail={dispatchDetail}
        />
      )}
      {removeTruckNotesModal && (
        <RemoveTruck
          replaceDriver={handleCancelTruck}
          setCancelledNotes={setCancelledNotes}
          cancelledNotes={cancelledNotes}
          handleCloseModal={() => setRemoveTruckNotesModal(false)}
        />
      )}
      {cancelTruckModal && (
        <SmConfirmModal
          heading="Remove Truck?"
          text="Are you sure you want to remove thist truck from the dispatch?"
          onCloseClick={() => setCancelTruckModal(false)}
          onOKClick={handleConfirmCancelTruck}
        />
      )}
      {props.snackBarVisible && <Snackbar text={props.snackBarCopy} />}
    </MainContainer>
  )
}

const mapStateToProps = state => {
  return {
    dispatches: state.dispatches,
    snackBarCopy: state.ui.snackBarCopy,
    snackBarVisible: state.ui.snackBarVisible,
    loading: state.dispatches.loading,
    drivers: state.drivers.driverList
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setSnackBarCopy,
      toggleSnackBar,
      sendDriverNotification,
      replaceDriver,
      cancelDriver
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(DispatchTrucks)
